<script setup>
import {defineProps, ref} from 'vue';

const props = defineProps(['service', 'protocolDescription', 'protocol_creator', 'protocol_accept']);
const protocolCreator = ref(props.protocol_creator || '');
const protocolAccept = ref(props.protocol_accept || '');
const protocolContent = ref(props.protocolDescription || '');

</script>

<style>
#projectTable tr th, #projectTable tr td {
  padding: .5rem;
}
</style>

<template>
  <AppLayout>
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 layout-spacing">
      <div class="widget widget-six">


        <div class="widget-heading pb-0 d-block">
          <div class="row">
            <div class="col-md-12 col-lg-10 d-flex align-items-center justify-content-between flex-wrap">
              <div>
                <h4 class="d-inline-block h4 me-4" style="line-height: 1.4">
                  Zgłoszenie: <b>{{ service.number }}</b>
                </h4>
                <span class="text-danger font-weight-bolder" v-if="service.archived">ZARCHIWIZOWANE</span>
              </div>
              <div class="ms-4">
                <Link :href="route('service.index')" class="btn btn-outline-primary">
                  <i class="bi bi-list"></i>&nbsp;Lista zgłoszeń
                </Link>
              </div>
            </div>
            <div class="col-md-12 col-lg-2 text-end">
              <form id="deleteServiceForm" class="d-inline-block me-2" method="post" @submit.prevent="deleteService">
                <input type="hidden" name="_token" :value="csrfToken">
                <button v-if="hasPermission('canDelService')" class="btn btn-outline-danger">Usuń zgłoszenie</button>
              </form>
            </div>
          </div>


          <div class="row">
            <div v-if="hasPermission('canEditService')" class="col-6 my-2">
              <form @submit.prevent="submitHideOnList" class="mt-3">
                <div class="checkbox-success custom-control custom-checkbox d-inline-block">
                  <input id="serviceHideOnList" type="checkbox" class="custom-control-input"
                         :checked="service.hide_on_list" @change="changeServiceHideOnList">
                  <label for="serviceHideOnList" class="custom-control-label h6">Nie pokazuj na liście zgłoszeń</label>
                </div>
                <button v-if="hideOnListServiceHasChanged" type="submit" class="btn btn-primary btn-sm ms-2">Zapisz
                </button>
              </form>
            </div>
            <div v-if="hasPermission('canEditService')" class="col-6 my-2">
              <form @submit.prevent="submitArchived" class="mt-3">
                <div class="checkbox-success custom-control custom-checkbox d-inline-block">
                  <input id="servicearchived" type="checkbox" class="custom-control-input"
                         :checked="service.archived" @change="changeServiceArchived">
                  <label for="servicearchived" class="custom-control-label h6">Archiwizuj zgłoszenie</label>
                </div>
                <button v-if="archivedHasChanged" type="submit" class="btn btn-primary btn-sm ms-2">Zapisz
                </button>
              </form>
            </div>
          </div>
          <serviceMenu :service="service"></serviceMenu>

        </div>


        <div class="widget-content">
          <div v-if="$page.props.errors">
            <ul style="list-style-type: none; padding: 0" v-for="error in $page.props.errors">
              <li class="alert alert-danger">{{ error }}</li>
            </ul>
          </div>

          <form @submit.prevent="submitOffer">


            <div class="row mt-3">
              <div class="col-md-6 col-lg-3 mb-3">
                <label class="form-label" for="protocolCreator">Protokół sporządził:</label>
                <input type="text" id="protocolCreator" class="form-control form-control-sm border-1"
                       v-model="protocolCreator"/>
              </div>
              <div class="col-md-6 col-lg-3 mb-3">
                <label class="form-label" for="protocolAccept">Protokół zatwierdził:</label>
                <input type="text" id="protocolAccept" class="form-control form-control-sm border-1"
                       v-model="protocolAccept">
              </div>
            </div>

            <div class="row">
              <div class="col-ms-12 col-md-6"></div>
            </div>
            <RichTextEditorComponent class="mt-2" id="editorProtocol" label="Protokół" modelName="protocol"
                                     :hidden="false" :modelText="protocolContent" @ctrl-s="modifySaveListener"
                                     @updateModel="updateProtocol"/>
            <div class="section">
              <div class="w-50 mx-auto d-flex justify-content-center gap-2">
                <a :href="route('service.generatePdfprotocol', { id: service.id })" class="btn btn-outline-info btn-sm"><i
                    class="bi bi-file-earmark-pdf"></i> Pobierz protokół</a>
                <a :href="route('service.viewPdfprotocol', { id: service.id })" rel="noopener noreferrer"
                   target="_blank" class="btn btn-outline-info btn-sm"><i class="bi bi-eye"></i> Podgląd</a>
                <div class="ms-auto">
                  <div class="row">
                    <button class="btn btn-primary float-end" type="button"
                            @click="saveProtocol" :disabled="loading">
						<span v-if="loading"
                  class="spinner-border spinner-border-sm text-white me-2 align-self-center loader-sm">
						  Ładuję...</span> Zapisz
                    </button>
                  </div>
                </div>
              </div>
            </div>

          </form>


        </div>
      </div>
    </div>
  </AppLayout>
</template>


<script>

import {Link, usePage} from "@inertiajs/vue3";
import {ref} from "vue";
import AppLayout from "@/Layouts/App.vue";

import RichTextEditorComponent from "@/Pages/Service/form-elements/RichTextEditorComponent.vue";
import tinymce from "tinymce";
import {useForm} from "@inertiajs/vue3";
import {usePermission} from "@/composables/resources/js/composables/permissions.js";
import serviceMenu from "@/Pages/Service/serviceMenu.vue";

const {hasPermission} = usePermission();

export default {
  components: {AppLayout, serviceMenu},

  props: {
    service: {
      type: Object,
      required: true,
      default: () => ({})
    },
    protocolDescription: {
      type: String,
      required: false,
      default: '',
    },
    protocol_creator: {
      type: String,
      required: false,
      default: '',
    },
    protocol_accept: {
      type: String,
      required: false,
      default: '',
    }
  }
  ,
  data() {
    return {
      hideOnListForm: useForm({
        hide_on_list: this.service.hide_on_list || false
      }),
      hideOnListServiceHasChanged: false,
      archiveOnListForm: useForm({
        archived: this.service.archived || false
      }),
      archivedHasChanged: false,
      isLoading: false,
      hasPermission,
      protocolContent: this.protocolDescription || "",
      protocol_creator: this.protocol_creator || "",
      protocol_accept: this.protocol_accept || "",


    };
  },

  mounted() {
    this.refreshEditor();
  },

  methods: {
    route,
    isRouteActive(routeName) {
      return route().current() === routeName;
    },

    refreshEditor() {
      this.protocolContent = "";
      this.$nextTick(() => {
        this.protocolContent = this.protocolDescription;
      });
    },


    changeServiceHideOnList() {
      this.hideOnListForm.hide_on_list = event.target.checked;
      this.hideOnListServiceHasChanged = true;
    },

    changeServiceArchived() {
      this.archiveOnListForm.archived = event.target.checked;
      this.archivedHasChanged = true;
    },
    updateProtocol(content) {
      this.protocolContent = content.value;
    },
    saveProtocol() {
      axios.post(route('service.protocol.save'), {
        service_id: this.service.id,
        description: this.protocolContent,
        protocol_creator: protocolCreator.value,
        protocol_accept: protocolAccept.value
      })
          .then(response => {
            this.showToast('success', 'Sukces', 'Protokół został zapisany.');
          })
          .catch(error => {
            console.error("Błędy walidacji:", error.response.data.errors);
            this.showToast('error', 'Błąd', 'Nie udało się zapisać protokołu.');
          });
    },

    submitHideOnList() {
      axios.post(route('service.updateHideOnList', {service: this.service.id}), {
        hide_on_list: this.hideOnListForm.hide_on_list
      })
          .then(() => {
            this.hideOnListServiceHasChanged = false;
            this.showToast('success', 'Sukces', 'Status ukrycia na liście został zaktualizowany.');
          })
          .catch(error => {
            console.error(error);
            this.showToast('error', 'Błąd', 'Nie udało się zapisać zmian.');
          });
    },
    deleteService(event) {
      const self = this;
      Toast.fire({
        toast: false,
        icon: 'warning',
        title: 'Usuwanie zgłoszenia',
        html: '<strong>Czy na pewno chcesz usunąć to zgłoszenie?</strong><br>Tej operacji nie można cofnąć!',
        showDenyButton: true,
        showConfirmButton: true,
        confirmButtonColor: '#d33',
        confirmButtonText: 'Tak, usuń',
        denyButtonText: 'Anuluj',
        position: 'center',
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
      }).then((result) => {
        if (result.isConfirmed) {
          axios.delete(route('service.destroy', this.service.id), {
            headers: {
              'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
            }
          }).then(response => {
            Toast.fire({
              icon: 'success',
              title: 'Zgłoszenie usunięte',
              html: '<strong>Zgłoszenie zostało pomyślnie usunięte.</strong><br>Za chwilę nastąpi przekierowanie...',
              timer: 3000,
              timerProgressBar: true,
            });
            setTimeout(() => {
              self.$inertia.visit(route('service.index'));
            }, 3000);
          }).catch(error => {
            console.error('Błąd usuwania:', error);
            Toast.fire({
              icon: 'error',
              title: 'Błąd usuwania',
              html: '<strong>Nie udało się usunąć zgłoszenia.</strong><br>Spróbuj ponownie później.',
            });
          });
        }
      });
    },

    submitArchived() {
      axios.post(route('service.updateArchived', {service: this.service.id}), {
        archived: this.archiveOnListForm.archived
      })
          .then(() => {
            this.archivedHasChanged = false;
            this.showToast('success', 'Sukces', 'Status archiwizacji został zaktualizowany.');
          })
          .catch(error => {
            console.error(error);
            this.showToast('error', 'Błąd', 'Nie udało się zapisać zmian.');
          });
    },

    showToast(icon, title, message) {
      Toast.fire({
        position: 'top-end',
        toast: true,
        icon: icon,
        title: title,
        html: message,
        showClass: {popup: 'animate__animated animate__fadeInDown'},
        hideClass: {popup: 'animate__animated animate__fadeOutUp'},
        timer: 2500,
        timerProgressBar: true,
        showConfirmButton: false,
        showCloseButton: true
      });
    }
  },
};

</script>


<style scoped>
.tooltip {
  opacity: 1 !important;
}
</style>
